'use client';

import { Box, Divider, Typography } from '@mui/material';
import { redirect } from 'next/navigation';
import React, { useEffect } from 'react';
import PDPInvestmentDetails from '@/containers/pdp/components/PDPInvestmentDetails';
import PDPBanner from '@/containers/pdp/components/PDPBanner';
import PDPTabs from '@/containers/pdp/components/PDPTabs';
import PageWithBreadcrumbs from '@/components/layout/PageWithBreadcrumbs';
import PDPProfitCalculator from '@/containers/pdp/components/PDPProfitCalculator';
import PDPComments from '@/containers/pdp/components/PDPComments';
import { useIsMobile } from '@/ui/kit/utils/useIsMobile';
import { usePdpInfo } from '@/api/hooks/usePdpInfo';
import { sendGoogleGTMEvent } from '@/utils/googleGTM';
const PDPContainer = () => {
  const {
    data
  } = usePdpInfo();
  const isMobile = useIsMobile();
  useEffect(() => {
    if (!data.id) return;
    sendGoogleGTMEvent({
      event: 'view_item',
      ecommerce: {
        items: [{
          item_id: data.id,
          item_name: data.title,
          thepercent: Math.floor(+data.providedFund / +data.maxInvestment * 100),
          index: 0
        }]
      }
    });
  }, [data?.id]);
  if (!data.id) {
    return redirect('/404');
  }
  return <PageWithBreadcrumbs breadCrumbLastItem={data.title} data-sentry-element="PageWithBreadcrumbs" data-sentry-component="PDPContainer" data-sentry-source-file="PDPContainer.tsx">
      <Typography sx={{
      typography: {
        xs: 'bodyLargeStrong__Wallfund',
        md: 'displayStrong__Wallfund'
      },
      display: {
        xs: 'none',
        md: 'flex'
      }
    }} component='h2' data-sentry-element="Typography" data-sentry-source-file="PDPContainer.tsx">
        {data.title}
      </Typography>
      <Box sx={{
      display: 'flex',
      flexDirection: {
        md: 'row',
        xs: 'column'
      },
      justifyContent: 'space-between',
      width: '100%',
      mt: {
        md: 'var(--spacing_l)'
      },
      mb: '80px',
      gap: 'var(--spacing_m)'
    }} data-sentry-element="Box" data-sentry-source-file="PDPContainer.tsx">
        <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        width: {
          md: 'calc(99% - 389px)',
          xs: '100%'
        },
        mb: 'var(--spacing_m)'
      }} data-sentry-element="Box" data-sentry-source-file="PDPContainer.tsx">
          <PDPBanner items={data.banners || []} data-sentry-element="PDPBanner" data-sentry-source-file="PDPContainer.tsx" />

          <Box sx={{
          bgcolor: 'background.bg',
          display: {
            xs: 'flex',
            md: 'none'
          },
          flexDirection: 'column',
          borderRadius: 'var(--corner_radius_m)',
          px: {
            xs: 'var(--spacing_m)',
            md: 'var(--spacing_m_nudge)'
          },
          py: {
            xs: 'var(--spacing_m)',
            md: 'var(--spacing_m_nudge)'
          },
          gap: 'var(--spacing_m)'
        }} data-sentry-element="Box" data-sentry-source-file="PDPContainer.tsx">
            {/* <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 'var(--spacing_xxs_nudge)',
                px: 'var(--spacing_m)',
              }}
             >
              <ApartmentTwoToneIcon />
              <Typography
                variant='captionMedium__Wallfund'
                color={'primaryBrand.text'}
              >
                {data.fundraiser}
              </Typography>
             </Box> */}
            <Typography sx={{
            typography: {
              xs: 'bodyLargeStrong__Wallfund',
              md: 'displayStrong__Wallfund'
            },
            px: 'var(--spacing_m)'
          }} component='h2' data-sentry-element="Typography" data-sentry-source-file="PDPContainer.tsx">
              {data.title}
            </Typography>
            <Divider data-sentry-element="Divider" data-sentry-source-file="PDPContainer.tsx" />
            <PDPInvestmentDetails data-sentry-element="PDPInvestmentDetails" data-sentry-source-file="PDPContainer.tsx" />
          </Box>

          <PDPProfitCalculator data={data} data-sentry-element="PDPProfitCalculator" data-sentry-source-file="PDPContainer.tsx" />

          <PDPTabs data-sentry-element="PDPTabs" data-sentry-source-file="PDPContainer.tsx" />

          {(data.addComments === 1 || data.showComments === 1) && <PDPComments />}
        </Box>
        {!isMobile && <PDPInvestmentDetails />}
      </Box>
    </PageWithBreadcrumbs>;
};
export default React.memo(PDPContainer);